interface Tab<T extends string> {
  value: T;
  label: string;
}

interface TabSwitcherProps<T extends string> {
  tabs: Tab<T>[];
  value: T;
  onChange: (value: T) => void;
}

export function TabSwitcher<T extends string>({ tabs, value, onChange }: TabSwitcherProps<T>) {
  return (
    <div className="inline-flex rounded-lg border border-gray-300 overflow-hidden">
      {tabs.map((tab) => (
        <button
          key={tab.value}
          onClick={() => onChange(tab.value)}
          className={`px-4 py-1.5 text-sm font-medium transition-colors ${
            value === tab.value
              ? "bg-primary text-white"
              : "bg-white text-gray-600 hover:bg-gray-50"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
